import MinusIcon from "@/shared/assets/icons/minus"
import PlusIcon from "@/shared/assets/icons/plus"
import { Button } from "@/shared/ui/button"
import { Flex, IconButton } from "@chakra-ui/react"

interface ICounter {
  variable: number
  bg?: string | Record<string, string>
  onIncrease: () => void
  onDecrease: () => void
  min?: number
  height?: number | string | any
  max?: number
  isDisabled?: boolean
}

export default function Counter({
  min,
  max,
  bg,
  variable,
  onIncrease,
  onDecrease,
  isDisabled,
  height,
}: ICounter) {
  return (
    <Flex
      w="full"
      rounded={12}
      alignItems="center"
      bg={bg ? bg : "light"}
      justify="space-between"
      h={height ? height : "auto"}
    >
      <IconButton
        h="full"
        pl={{ base: 2, lg: 3 }}
        variant="ghost"
        roundedLeft={12}
        onClick={onDecrease}
        justifyContent="flex-start"
        disabled={min === variable || isDisabled}
        flex={1}
      >
        <MinusIcon />
      </IconButton>

      <Button
        w="20px"
        color={"product_button.text"}
        fontWeight={600}
        variant="plain"
        size="sm"
      >
        {variable}
      </Button>

      <IconButton
        h="full"
        pr={{ base: 2, lg: 3 }}
        color={"text"}
        variant="ghost"
        roundedRight={12}
        onClick={onIncrease}
        justifyContent="flex-end"
        disabled={max === variable || isDisabled}
        flex={1}
      >
        <PlusIcon color="var(--product-btn-text)" />
      </IconButton>
    </Flex>
  )
}
